import { render } from "./exclamation-circle.vue?vue&type=template&id=c8aebbcc"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/exclamation-circle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8aebbcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8aebbcc', __exports__)) {
    api.reload('c8aebbcc', __exports__)
  }
  
  module.hot.accept("./exclamation-circle.vue?vue&type=template&id=c8aebbcc", () => {
    api.rerender('c8aebbcc', render)
  })

}


export default __exports__